// extracted by mini-css-extract-plugin
export var emptyState = "_4n-d";
export var statCard = "_4n-c";
export var table = "_4n-0";
export var tableCell = "_4n-4";
export var tableCellClickable = "_4n-5 _4n-4";
export var tableCellDefault = "_4n-6 _4n-4";
export var tableCellEmpty = "_4n-8";
export var tableCellWithValue = "_4n-7";
export var tableContainer = "_4n-e";
export var tableHeaderWeight = "_4n-1";
export var tableHeaderZone = "_4n-2";
export var tableRowHeader = "_4n-3";
export var viewModeButton = "_4n-9";
export var viewModeButtonActive = "_4n-a _4n-9";
export var viewModeButtonInactive = "_4n-b _4n-9";